import axios, {type AxiosError} from "axios";
import type {IInsufficientCreditsBody} from "../models/interfaces/credits.interface.ts";

export const isInsufficientCreditsError = (
  error: unknown
): error is AxiosError<IInsufficientCreditsBody> =>
  axios.isAxiosError<IInsufficientCreditsBody>(error) &&
  error.response?.status === 402 &&
  error.response.data?.code === 1010;
